import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import DataTable from 'react-data-table-component';
import { Card, Col, Row, Button } from 'react-bootstrap';
import DashboardHeader from './directives/DashboardHeader';
import './css/Dashboard.css';
import './css/Custom.css';
import { Link } from 'react-router-dom';
import config from '../../config/config';
import Web3 from 'web3';
import Cookies from 'js-cookie';
import { Toaster, toast } from 'react-hot-toast';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  getMyProjectAction,
  getTokenDetailsAction,
} from '../../apis/apiAction';
import Swal from 'sweetalert2';
import { formatUnits } from 'viem';

let loginWalletAddress = Cookies.get('walletAddress');

const Dashboard = ({ special, clearModalData }) => {
  const [myStakedProjectList, setMyStakedProjectList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMyProject, setIsLoadingMyProject] = useState(true);
  const [projectList, setProjectList] = useState([]);
  const [isClaimLoading, setLoader] = useState(false);

  useEffect(() => {
    if (loginWalletAddress) {
      setTimeout(() => {
        getMyStakedProjects();
        getMyProjectAPI();
      }, 1000);
    }
  }, []);

  const getMyProjectAPI = async () => {
    let res = await getMyProjectAction({ walletAddress: loginWalletAddress });
    setIsLoadingMyProject(false);
    if (res.status) {
      setProjectList(res.data);
    }
  };

  const getMyStakedProjects = async () => {
    try {
      if (window.ethereum) {
        const web3 = new Web3(window.ethereum);
        await window.ethereum.request({ method: 'eth_requestAccounts' });

        const contractInstance = new web3.eth.Contract(
          config.contractABI,
          config.contractAddress
        );
        // console.log(await contractInstance.methods, ".methods")
        const myStakedProject = await contractInstance.methods.getUserInvestments().call({ from: loginWalletAddress });
        // console.log('loginWalletAddressfssdffsdf', loginWalletAddress);
        // console.log('stffsdfsadfa', myStakedProject);
        setIsLoading(false);
        if (myStakedProject[0].length > 0) {
          // console.log(myStakedProject, "myStakedProject")
          const projectStakes = myStakedProject[0].map((_, i) => ({
            tokenAddress: myStakedProject.tokenAddresses[i],
            amount: web3.utils.fromWei(
              myStakedProject.amounts[i].toString(),
              'ether'
            ),
            startTime: new Date(
              Number(myStakedProject.startTimes[i]) * 1000
            ).toLocaleString(),
            maturityTime: new Date(
              Number(myStakedProject.maturityDates[i]) * 1000
            ).toLocaleString(),
            settledFlags: myStakedProject.settledFlags[i],
          }));
          // console.log(projectStakes, "projectStakes")
          // if (projectStakes && projectStakes.length > 0) {
          //   setMyStakedProjectList(projectStakes);

          //   const token = projectStakes[0].tokenAddress;
          //   // const user = "0x78d79b709c8a0b9d472730028604a2cf4db141aa";
          //   const user = "0xba2447f9f3f6a4b38e5718879af1c5633c7fae4e";


          //   // Create token contract to get decimals
          //   const tokenContract = new web3.eth.Contract(config.ERC20ABI, token);
          //   const decimals = await tokenContract.methods.decimals().call();

          //   // Convert 10 tokens into base units
          //   const parsedPrice = Web3.utils.toWei("10", decimals === "6" ? "mwei" : "ether");
          //   console.log("Token:", token);
          //   console.log("Decimals:", decimals);
          //   console.log("Parsed Price:", parsedPrice);
          //   console.log("Wallet:", user);
          //   try {
          //     const estimate = await contractInstance.methods
          //       .getExpectedReturnsInUsdt(user, token, parsedPrice)
          //       .call();
          //     console.log("Estimate:", estimate);
          //   } catch (err) {
          //     console.error("Contract reverted:", err.message);
          //     console.log({ user, token, parsedPrice });
          //   }
          // }

          if (projectStakes && projectStakes.length > 0) {
            const updatedStakes = await Promise.all(
              projectStakes.map(async (stake) => {
                try {
                  const token = stake.tokenAddress;
                  // const user = "0xba2447f9f3f6a4b38e5718879af1c5633c7fae4e";
                  const user = loginWalletAddress;


                  const tokenContract = new web3.eth.Contract(config.ERC20ABI, token);
                  const decimals = await tokenContract.methods.decimals().call();

                  const parsedPrice = Web3.utils.toWei("10", decimals === "6" ? "mwei" : "ether");

                  const estimate = await contractInstance.methods
                    .getExpectedReturnsInUsdt(user, token, parsedPrice)
                    .call();
                  // console.log("Estimate:", estimate);
                  const roiBigInt = estimate[0];
                  const bigin = roiBigInt[0]
                  const estimateValueStr = formatUnits(bigin, 18);
                  const estimateValueNum = Number(estimateValueStr);
                  // console.log(estimateValueNum, "estimateValueNum")

                  return {
                    ...stake,
                    // extimateReturn: Web3.utils.fromWei(estimate[0] ?? "0", "ether"),
                    estimateValueNum: estimateValueNum,
                  };
                } catch (err) {
                  // console.error("Contract reverted for token:", stake.tokenAddress, err.message);
                  return {
                    ...stake,
                    extimateReturn: "NA",
                  };
                }
              })
            );

            setMyStakedProjectList(updatedStakes);
          }


        }
      } else {
        toast.success('Please install MetaMask!');
      }
    } catch (error) {
      console.log(error);
    }
  };


  // console.log(myStakedProjectList, "myStakedProjectList aioefhhfhdhfh")

  const columns = [
    {
      name: 'S.No.',
      selector: (row, index) => index + 1,
    },
    {
      name: 'Token Address',
      selector: (row) =>
        `${row.tokenAddress.slice(0, 6)}.....${row.tokenAddress.slice(-6)}`,
      sortable: true,
    },
    {
      name: 'Amount',
      selector: (row) => `$${parseFloat(row.amount).toFixed(4)}`,
      sortable: true,
    },
    {
      name: 'Estimate Return',
      selector: (row) => {
        const value = row?.estimateValueNum;
        return value && value !== "0" ? `$${value}` : "NA";
      },
      sortable: true,
    },
    {
      name: 'Maturity Date',
      selector: (row) => row.maturityTime,
      sortable: true,
    },
    {
      name: 'Amount Settled',
      selector: (row) => (row.settledFlags === true ? 'Settled' : 'Not Settle'),
      sortable: true,
    },
    {
      name: 'Action',
      selector: (row) => (
        <>
          {isClaimLoading ? (
            <div className="p-sm-4 text-center">Processing</div>
          ) : (
            <Button
              variant="primary-gradient"
              className="w-100 border-0 px-md-1 small"
              onClick={() => claimUSDT(row)}
            >
              Claim
            </Button>
          )}
        </>
      ),
      sortable: true,
    },
  ];

  const projectcolumns = [
    {
      name: 'S.No.',
      selector: (row, index) => index + 1,
    },
    {
      name: 'Token Name ',
      selector: (row) => row.tokenName,
      sortable: true,
    },
    {
      name: 'Token Address',
      selector: (row) =>
        `${row.tokenAddress.slice(0, 6)}.....${row.tokenAddress.slice(-6)}`,
      sortable: true,
    },
    {
      name: 'Price',
      selector: (row) => `$${row.currentPrice}`,
      sortable: true,
    },
    {
      name: 'Principal',
      selector: (row) => `$${row.principal}`,
      sortable: true,
    },
    {
      name: 'Total Supply',
      selector: (row) => `${row.totalSupply}`,
      sortable: true,
    },
    {
      name: 'Action',
      selector: (row) => (
        <>
          <Button
            variant="primary-gradient"
            className="w-100 border-0 px-md-1 small"
            as={Link}
            to={`${config.baseUrl}projectoverview/${btoa(row.id.toString())}`}
          >
            View Details
          </Button>
        </>
      ),
      sortable: true,
    },
  ];

  const filteredData = myStakedProjectList.filter((data) => {
    const searchValue = searchQuery.toLowerCase();
    const combinedData = `
      ${data.tokenAddress || ''}
      ${data.amount || ''}
    `.toLowerCase();
    return combinedData.includes(searchValue);
  });

  const filteredMyProjectData = projectList.filter((data) => {
    const searchValue = searchQuery.toLowerCase();
    const combinedData = `
      ${data.tokenAddress || ''}
      ${data.amount || ''}
    `.toLowerCase();
    return combinedData.includes(searchValue);
  });
  const claimUSDT = async (data) => {
    try {
      if (!window.ethereum) {
        toast.error('MetaMask is not installed!');
        return;
      }

      if (!loginWalletAddress) {
        toast.error('Please connect your wallet');
        return;
      }

      let getTokenInfo = await getTokenDetailsAction({
        tokenAddress: data.tokenAddress,
      });
      if (getTokenInfo.status === false) {
        toast.error('Token information missing.');
        return;
      }

      let tokenClaimType = false;

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to claim as a Token form?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      });

      tokenClaimType = result.isConfirmed;

      setLoader(true);
      if (window.ethereum) {
        let fromAccount = loginWalletAddress;

        let web3 = new Web3(window.ethereum);
        const contractAddress = new web3.eth.Contract(
          config.contractABI,
          config.contractAddress
        );

        let currentPrice = getTokenInfo.data?.currentPrice;
        const currentPriceInWei = web3.utils.toWei(
          currentPrice.toString(),
          'ether'
        );

        const tx_builder = contractAddress.methods.repayment(
          data.tokenAddress.toString(),
          tokenClaimType,
          currentPriceInWei.toString()
        );

        const encoded_tx = tx_builder.encodeABI();
        const gasPrice = await web3.eth.getGasPrice();

        const gasLimit = await web3.eth.estimateGas({
          to: config.contractAddress,
          from: fromAccount,
          data: encoded_tx,
        });

        const txDataRes = await web3.eth.sendTransaction({
          gasPrice: web3.utils.toHex(gasPrice),
          gas: web3.utils.toHex(gasLimit),
          to: config.contractAddress,
          from: fromAccount,
          data: encoded_tx,
        });

        const txHash = txDataRes.transactionHash;
        if (txHash) {
          toast.success('Amount claimed successfully.');
        }
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      let errorMessage = 'Something went wrong';
      if (
        error?.data?.message ||
        error?.message?.includes('execution reverted')
      ) {
        errorMessage =
          error?.data?.message ||
          error?.message?.split('execution reverted:')[1]?.trim() ||
          'Transaction reverted';
      }
      toast.error(errorMessage);
      return;
    }
  };

  const customStyles = {
    table: {
      style: {
        borderRadius: '12px',
        border: '0.5px solid rgba(255, 255, 255, 0.10)',
        background: 'rgb(255, 255, 255, 0.00)',
        backdropFilter: 'blur(10px)',
      },
    },
    rows: {
      style: {
        minHeight: '52px',
        backgroundColor: 'transparent',
        '&:nth-of-type(odd)': {
          backgroundColor: 'transparent',
        },
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        backgroundColor: 'transparent',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'Center',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'Center',
      },
    },
    pagination: {
      style: {
        color: 'white',
        fontSize: '13px',
        minHeight: '56px',
        backgroundColor: 'transparent',
      },
      pageButtonsStyle: {
        borderRadius: '50%',
        height: '40px',
        width: '40px',
        padding: '8px',
        margin: '0px',
        cursor: 'pointer',
        transition: '0.4s',
        color: 'white',
        fill: 'white',
        backgroundColor: 'transparent',
        '&:disabled': {
          cursor: 'unset',
          color: 'white',
          fill: 'white',
        },
      },
    },
    noData: {
      style: {
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
        color: '#fff',
        fontSize: '16px',
      },
    },
  };

  return (
    <>
      <Toaster />
      <div
        className="w-100 d-grid"
        style={{ minHeight: '100vh', overflow: 'hidden' }}
      >
        <div className="d-flex  w-100 h-100">
          <div
            className="position-relative"
            style={{ borderRight: '1px solid rgba(255, 255, 255, 0.15)' }}
          >
            <Sidebar special={special} clearModalData={clearModalData} />
          </div>

          <div className="w-100" style={{ height: '100%' }}>
            <DashboardHeader />
            <div className="main-panel">
              <div
                className="content-wrapper px-4 px-lg-4"
                style={{
                  flex: '1',
                  backgroundColor: '#00021F',
                  color: '#ffffff',
                  height: '100%',
                  overflowY: 'auto',
                }}
              >
                <div className="heading py-4">
                  <h5 className="mb-0">Dashboard</h5>
                </div>
                <Row className="gy-3">
                  <Col xxl={8} xl={7} lg={12} md={12} sm={12} className="mb-4">
                    <Card className="dashboard-card dash-gradient2 overflow-hidden d-flex">
                      <Card.Body className="p-0">
                        <div className="d-sm-flex gap-3 align-items-center">
                          <div className="p-3 d-icon text-center">
                            <img
                              src="assets/images/utxIcon.png"
                              className=""
                              alt=""
                              width={`138px`}
                              height={`138px`}
                            />
                          </div>
                          <div className="box-content p-3">
                            <h5 className="text-white mb-xxl-4 lh-base">
                              Welcome to your new and Improved Dashboard
                            </h5>

                            <p className="mb-0 text-light-grey small">
                              UNITRONIX believe all project stakeholders are as
                              important as each other. Investment funds and
                              communities should work side by side on projects,
                              on the same terms, towards the same goals.
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col xxl={4} xl={5} lg={12} md={12} sm={12} className="mb-4">
                    <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bgparticle">
                      <Card.Body className="p-0">
                        <div className="socialmedia d-flex gap-3 justify-content-center align-items-center">
                          <div className="text-center">
                            <h5 className="text-white lh-base">
                              Stay on top of the game with updates from
                              Unitronix
                            </h5>
                            <p className="text-light-grey py-2 small">
                              Follow us on your Channel of Choice
                            </p>
                            <div className="socialIcon">
                              <a href="#" className="twitter me-3">
                                <img
                                  src="assets/images/dashboard/icon/twitter.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                              <a href="#" className="telegram me-3">
                                <img
                                  src="assets/images/dashboard/icon/telegram.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                              <a href="#" className="medium me-3">
                                <img
                                  src="assets/images/dashboard/icon/medium.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                              <a href="#" className="discord me-3">
                                <img
                                  src="assets/images/dashboard/icon/discord.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                              <a href="#" className="substack">
                                <img
                                  src="assets/images/dashboard/icon/substack.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="gy-3">
                  <Col
                    xxl={12}
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    className="mb-4"
                  >
                    <div className="heading py-4">
                      <h5 className="mb-0">
                        <span className="me-2">
                          <img
                            src="assets/images/utxIcon.png"
                            className=""
                            alt=""
                            width={`32px`}
                            height={`32px`}
                          />
                        </span>
                        My Projects
                      </h5>
                    </div>

                    <Card className="dashboard-card dash-gradient2 overflow-hidden d-flex mb-sm-4">
                      <Card.Body className="">
                        {isLoadingMyProject ? (
                          <div className="p-sm-4 text-center">
                            <img
                              src={`${config.baseUrl}assets/images/loader.gif`}
                              width="30px"
                            />
                          </div>
                        ) : projectList.length > 0 ? (
                          <DataTable
                            columns={projectcolumns}
                            data={filteredMyProjectData}
                            pagination
                            subHeader
                            customStyles={customStyles}
                            subHeaderComponent={
                              <input
                                type="text"
                                placeholder="Search..."
                                className="form-control"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ width: '300px' }}
                              />
                            }
                          />
                        ) : (
                          <div className="p-sm-4 text-center">
                            <p className="mb-0 text-light-grey mb-4 small lh-base">
                              You don't have projects.
                            </p>
                            <Link to={`${config.baseUrl}project`}>
                              <Button
                                variant="primary-gradient"
                                className="border-0"
                              >
                                View Unitronix Projects
                              </Button>
                            </Link>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="gy-3">
                  <Col
                    xxl={12}
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    className="mb-4"
                  >
                    <div className="heading py-4">
                      <h5 className="mb-0">
                        <span className="me-2">
                          <img
                            src="assets/images/utxIcon.png"
                            className=""
                            alt=""
                            width={`32px`}
                            height={`32px`}
                          />
                        </span>
                        My Staked Projects
                      </h5>
                    </div>

                    <Card className="dashboard-card dash-gradient2 overflow-hidden d-flex mb-sm-4">
                      <Card.Body className="">
                        {isLoading ? (
                          <div className="p-sm-4 text-center">
                            <img
                              src={`${config.baseUrl}assets/images/loader.gif`}
                              width="30px"
                            />
                          </div>
                        ) : myStakedProjectList.length > 0 ? (
                          <DataTable
                            columns={columns}
                            data={filteredData}
                            pagination
                            subHeader
                            customStyles={customStyles}
                            subHeaderComponent={
                              <input
                                type="text"
                                placeholder="Search..."
                                className="form-control"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ width: '300px' }}
                              />
                            }
                          />
                        ) : (
                          <div className="p-sm-4 text-center">
                            <p className="mb-0 text-light-grey mb-4 small lh-base">
                              You have not staked into any Unitronix Projects
                            </p>
                            <Link to={`${config.baseUrl}project`}>
                              <Button
                                variant="primary-gradient"
                                className="border-0"
                              >
                                View Unitronix Projects
                              </Button>
                            </Link>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;



